<template>
    <BreadCrumb PageTitle="Ajouter une composition" />
    <AddComposition />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddComposition from "@/components/Composition/AddComposition.vue";
  
    export default defineComponent({
      name: "AddCompositionPage",
      components: {
        BreadCrumb,
        AddComposition,
      },
    });
  </script>